import { useTranslation } from 'react-i18next';
import { YandexIcon } from '@shared/ui';
import { API_BASE_URL } from '@shared/api';
import { attributionSearch } from '@shared/lib/attribution';

// Вход через Google убран 2026-08-19 — на бэке остался единственный провайдер
// (`OAuthProviderName.yandex`), любой другой путь /auth/oauth/{provider}/login даёт 422.
type Provider = 'yandex';

// Метки визита — в query (B): бэкенд держит их на время OAuth и пишет атрибуцию новому пользователю.
// Строится в момент нажатия: атрибуция записана при старте приложения.
const oauthLoginUrl = (provider: Provider) => `${API_BASE_URL}/auth/oauth/${provider}/login${attributionSearch()}`;

export function SocialButtons({ onStart }: { onStart?: () => void }) {
  const { t } = useTranslation();

  const startOAuthLogin = (provider: Provider) => {
    onStart?.();
    window.location.href = oauthLoginUrl(provider);
  };

  return (
    <div className="flex gap-2.5">
      <button
        type="button"
        onClick={() => startOAuthLogin('yandex')}
        className="flex flex-1 items-center justify-center gap-2 rounded-xl border border-line bg-card px-3 py-3 text-[14px] font-medium transition-colors hover:bg-elev"
      >
        <YandexIcon className="h-4 w-4 rounded-[4px]" />
        {t('auth.social.yandex')}
      </button>
    </div>
  );
}
